import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L, { LatLngExpression, PolylineDecorator } from 'leaflet';

export function PlutoPolylineDecorator({ p }: { p: LatLngExpression[] }) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const x = new PolylineDecorator(p, {
      patterns: [
        {
          offset: 0,
          repeat: 200,
          symbol: L.Symbol.marker({
            rotate: true,
            markerOptions: {
              icon: ArrowMarker(),
            },
          }),
        },
      ],
    });
    x.addTo(map);

    return () => {
      x.removeFrom(map);
    };
  }, [map, p]);

  return null;
}

const arrow = `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" version="1.1">
    <g fill="white" strokeWidth="1" strokeOpacity="0.5" stroke="black">
      <path d="M 21 12 L 12 18 L 12 15 L 3 15 L 3 9 L 12 9 L 12 6 L 21 12"></path>
    </g>
  </svg>
`;

function ArrowMarker() {
  const htmlString = `
    <div style="transform: rotate(270deg); pointer-events: none;">
      ${arrow}
    </div>
  `;

  return new L.DivIcon({
    html: htmlString,
    iconSize: [24, 24],
    iconAnchor: [9, 9],
    popupAnchor: undefined,
  });
}
